import { AxiosResponse } from 'axios';
import cacheableRequest from '../../../services/cacheableRequest';
import { TrainingItem } from '../models/trainingItem';

type CompilationResponse = {
  _id: string;
  modifiedAt: string;
  name: string;
  description: string;
  image: string | null;
  trainingItems: (TrainingItem & { image: string | null })[];
};

export const getCompilation = (compilationId: string): Promise<CompilationResponse> => {
  return cacheableRequest(`/catalog/compilations/${compilationId}`).then(
    ({ data }: AxiosResponse<CompilationResponse>) => {
      return {
        ...data,
        id: data._id,
        trainingType: 'Compilation',
        modifiedTime: data.modifiedAt ? new Date(data.modifiedAt).getTime() : null,
        filterableData: [data.name],
        trainingItems: data.trainingItems.map(item => ({
          ...item,
          image: item.image || '',
        })),
      };
    }
  );
};
